// Shopify API types
export interface ShopifyProduct {
  id: string;
  handle: string;
  title: string;
  description: string;
  productType: string;
  tags: string[];
  priceRange: {
    minVariantPrice: {
      amount: string;
      currencyCode: string;
    };
  };
  variants: {
    edges: Array<{
      node: ShopifyVariant;
    }>;
  };
  images: {
    edges: Array<{
      node: {
        url: string;
        altText?: string;
      };
    }>;
  };
}

export interface ShopifyVariant {
  id: string;
  title: string;
  price: {
    amount: string;
    currencyCode: string;
  };
  availableForSale: boolean;
}

export interface ShopifyProductsResponse {
  products: {
    edges: Array<{
      node: ShopifyProduct;
    }>;
  };
}

export interface ShopifyAllProductsResponse {
  products: {
    edges: Array<{
      cursor: string;
      node: ShopifyProduct;
    }>;
    pageInfo: {
      hasNextPage: boolean;
      endCursor: string;
    };
  };
}

// Bundle-related types
export interface ShopifyBundle {
  id: string;
  handle: string;
  title: string;
  description: string;
  price: number;
  variants: ShopifyVariant[];
  images: Array<{
    url: string;
    altText?: string;
  }>;
  equipoComponent?: string; // Which equipo this bundle includes
  mascarillaComponent?: string; // Which mascarilla this bundle includes
}

// Mapping between our internal product structure and Shopify
export interface ProductMapping {
  internalId: string;
  shopifyHandle: string;
  type: 'equipo' | 'mascarilla';
}

// Product mappings for CPAP equipment and masks
export const PRODUCT_MAPPINGS: ProductMapping[] = [
  // CPAP Equipment
  { internalId: 'yuwell-yh-680b', shopifyHandle: 'yuwell-yh-680b-cpap', type: 'equipo' },
  { internalId: 'resmed-airsense-10', shopifyHandle: 'resmed-airsense-10-cpap', type: 'equipo' },
  
  // Masks
  { internalId: 'yuwell-yn-03', shopifyHandle: 'yuwell-yn-03-nasal-mask', type: 'mascarilla' },
  { internalId: 'yuwell-yf-02', shopifyHandle: 'yuwell-yf-02-oronasal-mask', type: 'mascarilla' },
  { internalId: 'resmed-airfit-n20', shopifyHandle: 'resmed-airfit-n20-nasal-mask', type: 'mascarilla' },
  { internalId: 'resmed-airfit-f20', shopifyHandle: 'resmed-airfit-f20-oronasal-mask', type: 'mascarilla' },
];